import jQuery from 'jquery';
import './styles/style.scss';

import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import pageAcademy from './routes/pageAcademy';
import pageLaExpoRegistration from './routes/pageLaExpoRegistration';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  /** All pages */
  common,
  /** Home page */
  home,
  pageAcademy,
  pageLaExpoRegistration,
});

/** Load Events */
jQuery(document).ready(() => routes.loadEvents());
